<template>
  <div :style="rootStyles" class="helmi-icon"/>
</template>

<script>
export default {
  name: 'HelmiIcon',

  props: {
    size: {
      type: Number,
      default: 32,
    },
  },

  computed: {
    rootStyles() {
      return {
        '--icon-height': `${this.size}px`,
      };
    },
  },
};
</script>

<style lang="scss">
.helmi-icon {
  margin-top: 1px;
  --icon-stroke: calc(var(--icon-height) / 16);
  --icon-offset: calc(var(--icon-height) / 8);
  --actual-height: calc(var(--icon-height) - var(--icon-offset));

  height: var(--icon-height);
  width: var(--icon-height);
  position: relative;

  &::after {
    content: "";
    background: linear-gradient(49deg, #0094be 0%, lighten(#0094be, 5) 100%);
    border-radius: 50% var(--icon-stroke);
    top: var(--icon-offset);
    height: var(--actual-height);
    position: absolute;
    left: var(--icon-offset);
    width: var(--actual-height);
    opacity: 0.6;
  }

  &::before {
    content: "";
    box-shadow: inset 0 0 0 var(--icon-stroke) darken(#0094be, 5);
    border-radius: 50% var(--icon-stroke);
    top: 0;
    height: var(--actual-height);
    position: absolute;
    left: 0;
    width: var(--actual-height);
    opacity: 0.6;
  }
}
</style>
